import {generateGuid} from "../../shared/services/utils";
import {getDeviceInfo} from "../storage/localStorage";

export const CLIENT_PROCESS_ID = generateGuid();

export const EVENTS = {
  SEARCH_INDEX_REBUILT: 'SearchIndexRebuiltEvent', APPLICATION_UPDATED: 'ApplicationUpdatedEvent',
  APPLICATION_INSTALLED: 'ApplicationInstalledEvent',
  EDITOR_FILE_CHANGED: 'EditorFileChangedEvent',
  FILE_BROWSER_FILE_SELECTED: 'FileBrowserFileSelectedEvent', TRANSPOSE_REQUESTED: 'TransposeRequestedEvent',
  CHANGE_NOTATION_REQUESTED: 'ChangeNotationRequestedEvent', URL_SONG_CHANGED: 'UrlSongChangedEvent',
  FILE_SAVED_TO_DATABASE: 'FileSavedToDatabaseEvent',
  FILE_BROWSER_RESIZED: 'FileBrowserResizedEvent', FILE_DELETED: 'FileDeletedEvent',
  FILE_RENAMED: 'FileRenamedEvent', UI_REFRESH_FILES: 'UIRefreshFilesEvent',
  ADD_SONG_REQUESTED: 'AddSongRequestedEvent', DELETE_SONG_REQUESTED: 'DeleteSongRequestedEvent',
  EDIT_SONG_POSITION_REQUESTED: 'EditSongPositionRequestedEvent'
};

export const SearchIndexRebuiltEvent = EVENTS.SEARCH_INDEX_REBUILT;
export const ApplicationUpdatedEvent = EVENTS.APPLICATION_UPDATED;
export const ApplicationInstalledEvent = EVENTS.APPLICATION_INSTALLED;
export const EditorFileChangedEvent = EVENTS.EDITOR_FILE_CHANGED;
export const FileBrowserFileSelectedEvent = EVENTS.FILE_BROWSER_FILE_SELECTED;
export const TransposeRequestedEvent = EVENTS.TRANSPOSE_REQUESTED;
export const ChangeNotationRequestedEvent = EVENTS.CHANGE_NOTATION_REQUESTED;
export const UrlSongChangedEvent = EVENTS.URL_SONG_CHANGED;
export const FileSavedToDatabaseEvent = EVENTS.FILE_SAVED_TO_DATABASE;
export const FileBrowserResizedEvent = EVENTS.FILE_BROWSER_RESIZED;
export const FileDeletedEvent = EVENTS.FILE_DELETED;
export const FileRenamedEvent = EVENTS.FILE_RENAMED;
export const UIRefreshFilesEvent = EVENTS.UI_REFRESH_FILES;
export const AddSongRequestedEvent = EVENTS.ADD_SONG_REQUESTED;
export const DeleteSongRequestedEvent = EVENTS.DELETE_SONG_REQUESTED;
export const EditSongPositionRequestedEvent = EVENTS.EDIT_SONG_POSITION_REQUESTED;

export class BroadcastChannelWrapper {
  constructor(eventName, onMessageHandler = null) {
    this.channel = new BroadcastChannel(eventName);
    this.eventName = eventName;
    if (onMessageHandler) this.channel.onmessage = onMessageHandler;
  }
  close() { this.channel.close(); }
  postMessage(message) {
    this.channel.postMessage({
      __deviceInfo: getDeviceInfo(), __processId: CLIENT_PROCESS_ID,
      __eventName: this.eventName, __timestamp: new Date().toISOString(), ...message,
    });
  }
}

const createChannelClass = eventName => class extends BroadcastChannelWrapper {
  constructor(onMessageHandler = null) { super(eventName, onMessageHandler); }
};

export const CHANNELS = {};
Object.entries(EVENTS).forEach(([key, eventName]) => CHANNELS[key] = createChannelClass(eventName));

export const SearchIndexRebuiltChannel = CHANNELS.SEARCH_INDEX_REBUILT;
export const ApplicationUpdatedChannel = CHANNELS.APPLICATION_UPDATED;
export const ApplicationInstalledChannel = CHANNELS.APPLICATION_INSTALLED;
export const FileSavedToDatabaseChannel = CHANNELS.FILE_SAVED_TO_DATABASE;
export const EditorFileChangedChannel = CHANNELS.EDITOR_FILE_CHANGED;
export const FileBrowserFileSelectedChannel = CHANNELS.FILE_BROWSER_FILE_SELECTED;
export const TransposeRequestedChannel = CHANNELS.TRANSPOSE_REQUESTED;
export const ChangeNotationRequestedChannel = CHANNELS.CHANGE_NOTATION_REQUESTED;
export const UrlSongChangedChannel = CHANNELS.URL_SONG_CHANGED;
export const FileBrowserResizedChannel = CHANNELS.FILE_BROWSER_RESIZED;
export const FileDeletedChannel = CHANNELS.FILE_DELETED;
export const FileRenamedChannel = CHANNELS.FILE_RENAMED;
export const UIRefreshFilesChannel = CHANNELS.UI_REFRESH_FILES;
export const AddSongRequestedChannel = CHANNELS.ADD_SONG_REQUESTED;
export const DeleteSongRequestedChannel = CHANNELS.DELETE_SONG_REQUESTED;
export const EditSongPositionRequestedChannel = CHANNELS.EDIT_SONG_POSITION_REQUESTED;
